export const LANGUAGE_OPTIONS = [
    {code: 'en', label: 'English'},
    {code: 'ta', label: '\u0ba4\u0bae\u0bbf\u0bb4\u0bcd (Tamil)'},
    {code: 'te', label: '\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41 (Telugu)'},
    {code: 'kn', label: '\u0c95\u0ca8\u0ccd\u0ca8\u0ca1 (Kannada)'},
    {code: 'ml', label: '\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02 (Malayalam)'},
    {code: 'hi', label: '\u0939\u093f\u0928\u094d\u0926\u0940 (Hindi)'}
];

export const getLanguagePageUrl = (pathname, language, search = '', hash = '') => {
    const parts = pathname.split('/').filter(Boolean);
    const codes = [...LANGUAGE_OPTIONS.map(item => item.code), 'ar'];
    if (codes.includes(parts[0])) parts.shift();
    return '/' + language + '/' + parts.join('/') + search + hash;
};
